import { ESelectedKpiType } from '../../enums';

export interface IMetric {
  dateOfTaking: string;
  value: number | null;
  fileId?: number;
}

export interface IDenoisedMetric {
  xCoordinate: number;
  yCoordinate: number;
}

export interface ISelectedKpiPoint {
  metricsList: IMetric[];
  type: ESelectedKpiType;
  metric: IMetric;
}
